import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { denormalizeData } from 'core/utils/api';
import { LocalStorage } from 'core/decorators';

import { sendOfflineEvents } from '../handlers';

function LastTopicsSaver(props, context) {
  const { bebopApi, counterIds } = context;

  useEffect(() => {
    if (process.env.NODE_ENV === 'test') return;

    const lastTopics = JSON.parse(LocalStorage.getItem('lastTopics'));

    if (!lastTopics || (lastTopics && lastTopics.expires < Date.now())) {
      bebopApi.getTopics({
        limit: '9',
        include: 'all',
      })
        .then(denormalizeData)
        .then(data => {
          const expires = Date.now() + 1000 * 60 * 60 * 24;
          LocalStorage.setItem('lastTopics', JSON.stringify({ expires, data }));
        });
    }
    if (navigator.onLine && counterIds && counterIds.yandexMetrika) {
      sendOfflineEvents(counterIds.yandexMetrika);
    }
  }, []); // eslint-disable-line

  return null;
}

LastTopicsSaver.contextTypes = {
  bebopApi: PropTypes.object.isRequired,
  counterIds: PropTypes.shape({
    yandexMetrika: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
  }),
};

export default LastTopicsSaver;
